import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useGiftItems(giftCategoryId: string) {
    const { data: items, status } = useQuery({
        ...queries.giftItem.list(giftCategoryId),
        enabled: !!giftCategoryId,
    });
    const toast = useToast();
    const { pop } = useFlow();
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('category.itemsLoadError'));
            pop();
        }
    }, [status, pop, toast, t]);
    return {
        items,
    };
}

export default useGiftItems;
